import React,{useState,useRef} from 'react'
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import BestSellerProduct from './BestSellerProduct'
import FirstTab from '../Home/FirstTab';
import image1 from '../../assets/homepage_t-ico1.png'
import image2 from '../../assets/homepage_t-ico2.png'
import image3 from '../../assets/homepage_t-ico3.png'
import image4 from '../../assets/homepage_t-ico4.png'
import image5 from '../../assets/homepage_t-ico5.png'
import image6 from '../../assets/homepage_t-ico6.png'
import { OffcanvasTitle } from 'react-bootstrap';
import OfferBanner from '../OfferBanner/OfferBanner';
import BannerCarousel from '../BannerCarousel/BannerCarousel';

const CategoryCarousel = () => {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const [sliderRef, setSliderRef] = useState(null)
    const ref = useRef()
    return (
        <>
            <div className="col-md-9 cat-slide-sec">
                <h2 className="title1">Top Categories</h2>
                    <Slider {...settings}>
                        <div className='cat-slide'>
                             <img src={image1} alt="" />
                        </div>
                        <div className='cat-slide'>
                             <img src={image2} alt="" />
                        </div> 
                        <div className='cat-slide'>
                             <img src={image3} alt="" />
                        </div>
                        <div className='cat-slide'>
                             <img src={image4} alt="" />
                        </div>
                        <div className='cat-slide'>
                             <img src={image5} alt="" />
                        </div>
                        <div className='cat-slide'>
                             <img src={image6} alt="" />
                        </div>      
                    </Slider>
                    <div style={{marginTop:'35px'}}>
                    <FirstTab/>
                    </div>
                    <BestSellerProduct/>
                    <OfferBanner/>
                    <BannerCarousel/>
                </div>
        </>
    )
}

export default CategoryCarousel